import { ChangeDetectionStrategy, Component, HostBinding, Input, inject } from '@angular/core';

import { StringDictionary } from '@frontend/sports/common/core/utils/extended-types';
import { GridEvent } from '@frontend/sports/grid/core/feature/model';
import { DeviceService } from '@frontend/vanilla/core';

import { BadgeComponent } from '../../crm-promotion/badge.component';
import { EventInfoComponent } from './event-info.component';
import { EventNameComponent } from './event-name.component';
import { GameNotesComponent } from './game-notes.component';

@Component({
    selector: 'ms-event-detail',
    templateUrl: './event-detail.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [EventInfoComponent, EventNameComponent, GameNotesComponent, BadgeComponent],
})
export class EventDetailComponent {
    private deviceService = inject(DeviceService);

    @Input() event: GridEvent;
    @Input() mediaEnabled: boolean;
    @Input() promotedFixtureIdsMap: StringDictionary<string> = {};
    @Input() showEventTimerInfoSection = true;
    @Input() showParticipantImage: boolean;
    @Input() gameNotes?: string;
    @Input() showParticipantStats = false;
    @Input() showLogoColor: boolean;
    @Input() isAllMarketsLinkEnabled: boolean;
    @Input() showTimeInfoOnTop = false;
    @Input() showPromotionBadge = false;
    @Input() showPlayerStatisticsButton = false;
    disableBadges = this.shouldDisableBadges();

    @HostBinding('class') className = 'grid-event-detail';

    private shouldDisableBadges(): boolean {
        return this.event && !!this.promotedFixtureIdsMap[this.event.id] && this.isMobilePhone && !this.showPromotionBadge;
    }

    get isMobilePhone(): boolean {
        return this.deviceService.isMobilePhone;
    }
}
